import React, { useState } from "react";
import InfoBox from "./InfoBox";
import { LegendProps } from "../../types";
import generateSvg from "../../util/generateSvg";

import "../../styles/Legend.css";

const Legend = ({ data, node, setNode }: LegendProps) => {
  const [generatingSvg, setGeneratingSvg] = useState<boolean>(false);

  const downloadSvg = async (networkName: string) => {
    setGeneratingSvg(true);
    setTimeout(async () => {
      await generateSvg(
        `Workspace map of ${networkName} - ${new Date().toDateString()}`
      );
      setGeneratingSvg(false);
    }, 5); // This gives the dom enough time to update
  };

  return (
    <legend className="be_legend">
      <ul className="be_legendTextContainer">
        <div>
          <p className="be_headerForUpper">
            <b>How to use Bird&#39;s eye:</b>
          </p>
          <p style={{ fontSize: ".9em" }}>
            Click a Dataset or a Workflow to see phase information and
            connections{" "}
          </p>
          <p style={{ fontSize: ".9em" }}>
            Close the phase window to return to normal view
          </p>
        </div>
        <li>
          <span
            className="be_dot"
            style={{
              background: "var(--primary-500, #253c56)",
              marginBottom: "3px",
            }}
          ></span>
          <span className="be_desc">Dataset</span>
        </li>
        <li>
          <span
            className="be_dot"
            style={{
              background: "var(--accent-800, #138637)",
              marginBottom: "3px",
            }}
          ></span>
          <span className="be_desc">Workflow</span>
        </li>
        <button
          className="be_downloadButton"
          onClick={() => {
            downloadSvg(data.name);
          }}
        >
          <p>{generatingSvg ? "Generating..." : "Download Map"}</p>
        </button>
      </ul>
      <InfoBox data={data} node={node} setNode={setNode} />
    </legend>
  );
};

export default Legend;
